// extracted by mini-css-extract-plugin
module.exports = {"container":"_1bt7X","label":"_2FQUa","price":"_1T1z9"};